<!--
 * @Description: 云途销售线索 - 新增页面
 * @Author: mdb
 * @Date: 2022-07-16 10:45:39
 * @LastEditTime: 2022-11-23 16:56:59
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm ref="detailFormRef" type="add" isEdit v-model:value="dataForm" :resetValue="initForm" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import type { LbuSalesClueEditParams } from '@/typings/api/clueManage'

const initForm: LbuSalesClueEditParams.RootObject = reactive({
  clueStatus: 3,
  contact: {},
  business: { saleInfo: [{}], demandInfo: [{}], erpInfo: [{}] },
  visitAddress: [{}]
})
const dataForm = reactive<LbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
</script>
<script lang="ts">
export default { name: 'DcCosLbuSalesClueAdd' }
</script>

<style scoped></style>
